/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
    // Add custom code below this line
  
    const hiddenQuantityProperty = '_hide_qty';
    const bundleRoleProperty = '_bundle_role';
    const bundleProductIdProperty = '_bundle_product_id';
    const lockedQuantityClass = 'rebuy-cart__flyout-item-quantity-locked';
    const removeButtonLoadingClass = 'is-removing';
    const removeLoaderMarkup = '<svg class="rebuy-cart__remove-loader" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4.05543 11.8055C4.10055 12.0604 4.05543 12.2555 3.93532 12.3756C3.8152 12.4958 3.60544 12.5256 3.3652 12.4659L0.440796 11.6104C-0.0543242 11.4757 -0.143964 11.0702 0.231036 10.7257L1.02616 9.9909C1.01092 9.97566 1.01092 9.96101 0.996273 9.94578C-0.624477 7.21533 -0.0543121 3.81048 2.16581 1.75548C2.49569 1.44024 2.87069 1.17072 3.27557 0.91524C4.28045 0.31524 5.37557 0.01524 6.47072 0V0.99024C5.55548 1.02012 4.62557 1.275 3.78602 1.77012C3.4409 1.97988 3.12626 2.22012 2.8409 2.475C0.980598 4.2 0.486048 7.02015 1.76102 9.3L2.57078 8.55C2.94578 8.20488 3.33602 8.325 3.4409 8.82012L4.05543 11.8055ZM9.96573 4.41038C10.0706 4.9055 10.4609 5.02562 10.8359 4.6805L11.6456 3.9305C12.9206 6.21035 12.4255 9.0305 10.5804 10.7555C10.2956 11.0256 9.98037 11.2506 9.63525 11.4604C8.79501 11.9701 7.8651 12.2104 6.95055 12.2403V13.2305C8.04567 13.2006 9.14085 12.9006 10.1457 12.3153C10.5506 12.075 10.9256 11.7903 11.2555 11.475C13.4609 9.42017 14.0158 6.01532 12.3957 3.30002C12.3805 3.28478 12.3805 3.27014 12.3658 3.2549L13.1609 2.52014C13.5359 2.17502 13.4457 1.77014 12.9512 1.63538L10.0262 0.795141C9.78594 0.720141 9.57618 0.765258 9.45606 0.885375C9.33594 1.00549 9.27618 1.20062 9.33594 1.4555L9.96573 4.41038Z" fill="currentColor"/></svg>';
    const themeAtcGuardMs = 5000;
    const orphanCleanupDelayMs = 150;
    const giftQtyNormalizeDelayMs = 150;
    let bundleCascadeLock = false;
    let orphanCleanupTimer = null;
    let giftQtyNormalizeLock = false;
    let giftQtyNormalizeTimer = null;
    let giftCartLineKeys = new Set();
    let giftCartVariantIds = new Set();
    let inferredAtcMinQty = new Map();
    let lastCartJson = null;
    let bundleItemsAddInFlight = false;
      let themeBundleAtcGuard = {
        active: false,
        variantId: '',
        productId: '',
        expiresAt: 0,
        // First matching /cart/add during the guard window is allowed; further
        // matching adds (Rebuy / Moon-expanded {items:…} duplicates) are blocked.
        primaryAddConsumed: false,
      };
  
    const getItemProperty = (item, propertyName) => {
      if (!item || !item.properties) {
        return '';
      }
  
      const properties = item.properties;
  
      if (!Array.isArray(properties) && typeof properties === 'object') {
        const value = properties[propertyName];
  
        if (value === true || value === false) {
          return String(value);
        }
  
        return value != null ? String(value) : '';
      }
  
      if (!Array.isArray(properties)) {
        return '';
      }
  
      for (const property of properties) {
        if (!property) {
          continue;
        }
  
        const key = property.key || property.name || property[0];
        const value = property.value || property[1];
  
        if (key === propertyName && value != null) {
          return String(value);
        }
      }
  
      return '';
    };
  
    const getBundleProductIdFromItem = (item) => {
      const bundleProductId = getItemProperty(item, bundleProductIdProperty);
  
      if (bundleProductId) {
        return bundleProductId;
      }
  
      if (getItemProperty(item, bundleRoleProperty) === 'main' && item.product_id) {
        return String(item.product_id);
      }
  
      return '';
    };

    const itemHasSellingPlan = (item) => {
      if (!item) {
        return false;
      }

      if (item.selling_plan_id || item.selling_plan) {
        return true;
      }

      return Boolean(item.selling_plan_allocation);
    };

    const getPurchaseModeFromItem = (item) => {
      return getItemProperty(item, '_purchase_mode');
    };

    const isOtpBundleMainItem = (item) => {
      if (getItemProperty(item, bundleRoleProperty) !== 'main') {
        return false;
      }

      const purchaseMode = getPurchaseModeFromItem(item);

      if (purchaseMode === 'otp') {
        return true;
      }

      if (purchaseMode === 'subscribe') {
        return false;
      }

      return !itemHasSellingPlan(item);
    };

    const isSubscribeMainItem = (item) => {
      if (getItemProperty(item, bundleRoleProperty) !== 'main') {
        return false;
      }

      const purchaseMode = getPurchaseModeFromItem(item);

      if (purchaseMode === 'subscribe') {
        return true;
      }

      if (purchaseMode === 'otp') {
        return false;
      }

      return itemHasSellingPlan(item);
    };

    const getAtcGroupFromItem = (item) => {
      return getItemProperty(item, '_atc_group') || getItemProperty(item, '_bundle_key');
    };

    const rememberAtcMinQuantities = (cart) => {
      if (!cart || !cart.items) {
        return;
      }

      for (const item of cart.items) {
        if (!item || !item.key || !isSubscribeBundleQtyProtectedItem(item) || inferredAtcMinQty.has(item.key)) {
          continue;
        }

        const stamped = Number(getItemProperty(item, '_atc_qty'));
        inferredAtcMinQty.set(item.key, stamped > 0 ? stamped : (Number(item.quantity) || 1));
      }
    };

    const setLastCartJson = (cart) => {
      if (!cart || !Array.isArray(cart.items)) {
        return;
      }

      lastCartJson = cart;
      rememberAtcMinQuantities(cart);
    };

    const getKnownCart = () => {
      if (lastCartJson && Array.isArray(lastCartJson.items)) {
        return lastCartJson;
      }

      if (window.Rebuy && window.Rebuy.Cart && window.Rebuy.Cart.cart && Array.isArray(window.Rebuy.Cart.cart.items)) {
        return window.Rebuy.Cart.cart;
      }

      return null;
    };

    const buildCartWithoutKeys = (cart, lineKeys) => {
      if (!cart || !cart.items) {
        return { items: [], item_count: 0 };
      }

      const removedKeys = new Set(lineKeys);
      const items = [];
      let itemCount = 0;

      for (const item of cart.items) {
        if (item && item.key && removedKeys.has(item.key)) {
          continue;
        }

        items.push(item);
        itemCount += Number(item.quantity) || 0;
      }

      const nextCart = {};

      for (const key of Object.keys(cart)) {
        nextCart[key] = cart[key];
      }

      nextCart.items = items;
      nextCart.item_count = itemCount;

      return nextCart;
    };

    const getAtcMinQtyFromItem = (item) => {
      const stamped = Number(getItemProperty(item, '_atc_qty'));

      if (stamped > 0) {
        return stamped;
      }

      if (item && item.key && inferredAtcMinQty.has(item.key)) {
        return inferredAtcMinQty.get(item.key);
      }

      return Number(item && item.quantity) || 1;
    };

    const isSubscribeBundleQtyProtectedItem = (item) => {
      if (!item || isOtpBundleMainItem(item) || getItemProperty(item, bundleRoleProperty) === 'gift') {
        return false;
      }

      if (isSubscribeMainItem(item)) {
        return true;
      }

      return Boolean(getAtcGroupFromItem(item) && itemHasSellingPlan(item));
    };

    const shouldRemoveBundleForQuantityChange = (item, nextQty) => {
      if (!item || nextQty === null || Number.isNaN(nextQty)) {
        return false;
      }

      if (!isSubscribeBundleQtyProtectedItem(item)) {
        return false;
      }

      return Number(nextQty) < getAtcMinQtyFromItem(item);
    };

    const getRebuyElementProperties = (itemElement) => {
      const properties = {};

      if (!itemElement || !itemElement.className) {
        return properties;
      }

      const className = typeof itemElement.className === 'string' ? itemElement.className : '';
      const classes = className.split(/\s+/);

      for (const itemClass of classes) {
        if (itemClass.indexOf('property-') !== 0) {
          continue;
        }

        if (itemClass.indexOf('property-key-') === 0 || itemClass.indexOf('property-value-') === 0) {
          continue;
        }

        const withoutPrefix = itemClass.slice(9);
        const colonIndex = withoutPrefix.indexOf(':');

        if (colonIndex <= 0) {
          continue;
        }

        properties[withoutPrefix.slice(0, colonIndex)] = withoutPrefix.slice(colonIndex + 1);
      }

      return properties;
    };
  
    const hasHiddenQuantityProperty = (item) => {
      const value = getItemProperty(item, hiddenQuantityProperty);
      return value === 'true';
    };
  
    const getSmartCart = () => {
      if (!window.Rebuy || !window.Rebuy.SmartCart) {
        return null;
      }
  
      return window.Rebuy.SmartCart;
    };

    let pendingRebuyCartOpen = false;

    const closeThemeCartDrawer = () => {
      const cartDrawer = document.querySelector('cart-element[data-cart-drawer]');

      if (!cartDrawer || !cartDrawer.isCartDrawerOpen) {
        document.body.classList.remove('js-drawer-open-cart');
        return;
      }

      if (typeof cartDrawer.closeCartDrawer === 'function') {
        cartDrawer.closeCartDrawer();
        return;
      }

      document.body.classList.remove('js-drawer-open-cart');
      cartDrawer.classList.remove('is-open');
    };

    const openRebuySmartCart = (queueIfMissing) => {
      if (window.__REBUY_BLOCKED__) {
        pendingRebuyCartOpen = false;
        return false;
      }

      const smartCart = getSmartCart();

      if (!smartCart || typeof smartCart.show !== 'function') {
        if (queueIfMissing) {
          pendingRebuyCartOpen = true;
        }

        return false;
      }

      pendingRebuyCartOpen = false;
      smartCart.show();
      return true;
    };

    const patchThemeCartDrawerForRebuy = () => {
      const cartDrawer = document.querySelector('cart-element[data-cart-drawer]');

      if (!cartDrawer || cartDrawer.__rebuyCartPatched || typeof cartDrawer.openCartDrawer !== 'function') {
        return Boolean(cartDrawer && cartDrawer.__rebuyCartPatched);
      }

      const originalOpen = cartDrawer.openCartDrawer.bind(cartDrawer);

      cartDrawer.openCartDrawer = function() {
        if (openRebuySmartCart(true)) {
          return;
        }

        return originalOpen();
      };

      cartDrawer.__rebuyCartPatched = true;
      return true;
    };
  
    const isMwBundleCartItem = (item) => {
      if (!item || !item.properties) {
        return false;
      }
  
      const properties = item.properties;
  
      if (!Array.isArray(properties) && typeof properties === 'object') {
        return Boolean(properties.__mw_build || properties._mw_marketing_offers_offer_id);
      }
  
      if (!Array.isArray(properties)) {
        return false;
      }
  
      for (const property of properties) {
        if (!property) {
          continue;
        }
  
        const key = property.key || property.name || property[0];
  
        if (key === '__mw_build' || key === '_mw_marketing_offers_offer_id') {
          return true;
        }
      }
  
      return false;
    };
  
    const isMwBundleCartPayload = (payload) => {
      if (!payload) {
        return false;
      }
  
      if (isMwBundleCartItem(payload)) {
        return true;
      }
  
      if (!payload.items || !Array.isArray(payload.items)) {
        return false;
      }
  
      for (const item of payload.items) {
        if (isMwBundleCartItem(item)) {
          return true;
        }
      }
  
      return false;
    };
  
    const handleMwBundleCartAddSuccess = (payload) => {
      if (!isMwBundleCartPayload(payload)) {
        return;
      }
  
      if (payload && payload.items) {
        syncRebuyCartState(payload);
      } else {
        fetchCartJson()
          .then((cart) => {
            syncRebuyCartState(cart);
          })
          .catch(() => null);
      }
  
      openRebuySmartCart();
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      scheduleGiftQtyNormalization();
    };
  
    const registerMwBundleCartDrawerBridge = () => {
      if (window.mwBundleCartDrawerBridgeRegistered) {
        return;
      }
  
      window.mwBundleCartDrawerBridgeRegistered = true;
  
      class MwBundleRebuyCartDrawerBridge extends HTMLElement {
        connectedCallback() {
          this.setAttribute('data-rebuy-cart-bridge', 'true');
          this.setAttribute('aria-hidden', 'true');
          this.hidden = true;
        }
  
        renderContents(cartState) {
          handleMwBundleCartAddSuccess(cartState);
          this.classList.remove('is-empty');
        }
  
        open() {
          fetchCartJson()
            .then((cart) => {
              syncRebuyCartState(cart);
              openRebuySmartCart();
            })
            .catch(() => {
              openRebuySmartCart();
            });
        }
      }
  
      if (!customElements.get('cart-drawer')) {
        customElements.define('cart-drawer', MwBundleRebuyCartDrawerBridge);
      }
  
      if (!document.querySelector('cart-drawer[data-rebuy-cart-bridge="true"]')) {
        document.body.appendChild(document.createElement('cart-drawer'));
      }
    };
  
    registerMwBundleCartDrawerBridge();
  
    const getCartRootUrl = () => {
      if (window.theme && window.theme.routes && window.theme.routes.root) {
        return window.theme.routes.root;
      }
  
      return '/';
    };
  
    const getCartUpdateUrl = () => {
      if (window.theme && window.theme.routes && window.theme.routes.cart_update_url) {
        return window.theme.routes.cart_update_url;
      }
  
      return '/cart/update.js';
    };
  
    const fetchCartJson = () => {
      return fetch(getCartRootUrl() + 'cart.js', {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }
  
        return response.json();
      }).then((cart) => {
        setLastCartJson(cart);
        return cart;
      });
    };
  
    const getOrphanGiftLineKeys = (cart) => {
      if (!cart || !cart.items) {
        return [];
      }

      const subscribeGroups = new Set();
      const orphanKeys = [];

      for (const item of cart.items) {
        if (!isSubscribeMainItem(item)) {
          continue;
        }

        const atcGroup = getAtcGroupFromItem(item);

        if (atcGroup) {
          subscribeGroups.add(atcGroup);
        }
      }

      for (const item of cart.items) {
        if (getItemProperty(item, bundleRoleProperty) !== 'gift' || !item.key) {
          continue;
        }

        const atcGroup = getAtcGroupFromItem(item);

        if (atcGroup && subscribeGroups.has(atcGroup)) {
          continue;
        }

        if (atcGroup) {
          orphanKeys.push(item.key);
        }
      }

      return [...new Set(orphanKeys)];
    };

    const getBundleLineKeysToRemoveForMain = (cart, removedMainKey) => {
      if (!cart || !cart.items || !removedMainKey) {
        return [];
      }

      let removedMainItem = null;

      for (const item of cart.items) {
        if (item.key === removedMainKey) {
          removedMainItem = item;
          break;
        }
      }

      if (!removedMainItem || isOtpBundleMainItem(removedMainItem)) {
        return [removedMainKey];
      }

      const atcGroup = getAtcGroupFromItem(removedMainItem);

      if (!atcGroup) {
        return [removedMainKey];
      }

      const lineKeys = [];

      for (const item of cart.items) {
        if (getAtcGroupFromItem(item) === atcGroup && item.key) {
          lineKeys.push(item.key);
        }
      }

      return lineKeys.length > 0 ? [...new Set(lineKeys)] : [removedMainKey];
    };

    const resolveShopifyLineKey = (cart, matchedItem) => {
      if (!matchedItem) {
        return '';
      }

      if (!cart || !cart.items) {
        return matchedItem.key || '';
      }

      if (matchedItem.key) {
        for (const item of cart.items) {
          if (item.key === matchedItem.key) {
            return item.key;
          }
        }
      }

      const variantId = String(matchedItem.variant_id || matchedItem.id || '');
      const bundleKey = getItemProperty(matchedItem, '_bundle_key');
      const candidates = [];

      for (const item of cart.items) {
        if (variantId && String(item.variant_id) === variantId) {
          candidates.push(item);
        }
      }

      if (candidates.length === 1 && candidates[0].key) {
        return candidates[0].key;
      }

      if (bundleKey) {
        for (const item of candidates) {
          if (getItemProperty(item, '_bundle_key') === bundleKey && item.key) {
            return item.key;
          }
        }
      }

      return matchedItem.key || '';
    };
  
    const getKnownCartItemCount = (cart) => {
      if (!cart || typeof cart !== 'object') {
        return null;
      }

      if (typeof cart.item_count === 'number') {
        return cart.item_count;
      }

      if (cart.token && Array.isArray(cart.items)) {
        let count = 0;

        for (const item of cart.items) {
          count += Number(item.quantity) || 0;
        }

        return count;
      }

      return null;
    };

    const syncHeaderCartToggle = (cart) => {
      const itemCount = getKnownCartItemCount(cart);

      if (itemCount === null) {
        return;
      }

      const toggles = document.querySelectorAll('.cart__toggle');

      for (const toggle of toggles) {
        if (itemCount > 0) {
          toggle.classList.add('cart__toggle--has-items');
        } else {
          toggle.classList.remove('cart__toggle--has-items');
        }
      }
    };

    const getRebuyCartState = (event) => {
      if (event && event.detail) {
        if (event.detail.cart) {
          return event.detail.cart;
        }

        if (typeof event.detail.item_count === 'number') {
          return event.detail;
        }
      }

      if (window.Rebuy && window.Rebuy.Cart && window.Rebuy.Cart.cart) {
        return window.Rebuy.Cart.cart;
      }

      return null;
    };

    const syncHeaderCartToggleFromEvent = (event) => {
      const cart = getRebuyCartState(event);

      if (getKnownCartItemCount(cart) !== null) {
        syncHeaderCartToggle(cart);
        return;
      }

      fetchCartJson()
        .then((freshCart) => {
          syncHeaderCartToggle(freshCart);
        })
        .catch(() => {});
    };

    const syncRebuyCartState = (cart) => {
      const rebuyCart = window.Rebuy && window.Rebuy.Cart;
      const smartCart = getSmartCart();
  
      if (rebuyCart && typeof rebuyCart.setCart === 'function') {
        rebuyCart.setCart(cart);
      }
  
      if (smartCart && typeof smartCart.setCart === 'function') {
        smartCart.setCart(cart);
      }

      syncHeaderCartToggle(cart);
      setLastCartJson(cart);
    };
  
    const bulkRemoveCartLines = (lineKeys) => {
      if (!lineKeys || lineKeys.length === 0) {
        return Promise.resolve(null);
      }
  
      const updates = {};
  
      for (const lineKey of lineKeys) {
        if (!lineKey) {
          continue;
        }

        updates[lineKey] = 0;
      }

      if (Object.keys(updates).length === 0) {
        return Promise.resolve(null);
      }
  
      return fetch(getCartUpdateUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          updates,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
  
          return response.json();
        })
        .then((cart) => {
          refreshGiftLineKeyCache(cart);
          syncRebuyCartState(cart);
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          return cart;
        });
    };
  
    const isBundleGiftItem = (item) => {
      return getItemProperty(item, bundleRoleProperty) === 'gift';
    };
  
    const refreshGiftLineKeyCache = (cart) => {
      giftCartLineKeys = new Set();
      giftCartVariantIds = new Set();
      setLastCartJson(cart);
      rememberAtcMinQuantities(cart);
  
      if (!cart || !cart.items) {
        return;
      }
  
      for (const item of cart.items) {
        if (!isBundleGiftItem(item)) {
          continue;
        }

        if (item.key) {
          giftCartLineKeys.add(item.key);
        }

        if (item.variant_id) {
          giftCartVariantIds.add(String(item.variant_id));
        }
      }
    };
  
    const warmGiftLineKeyCache = () => {
      return fetchCartJson()
        .then((cart) => {
          refreshGiftLineKeyCache(cart);
          return cart;
        })
        .catch(() => null);
    };
  
    const hasGiftItemsInCart = () => {
      return giftCartLineKeys.size > 0;
    };
  
    const isCartChangeFetchUrl = (url) => {
      if (!url) {
        return false;
      }
  
      return /\/cart\/change\.js(\?|$)/.test(String(url));
    };
  
    const isCartUpdateFetchUrl = (url) => {
      if (!url) {
        return false;
      }
  
      return /\/cart\/update\.js(\?|$)/.test(String(url));
    };
  
    const parseCartChangeBody = (init) => {
      const result = {
        lineKey: '',
        line: null,
        quantity: null,
      };
  
      if (!init || !init.body) {
        return result;
      }

      if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
        result.lineKey = String(init.body.get('id') || '');

        const lineValue = init.body.get('line');
        const quantityValue = init.body.get('quantity');

        if (lineValue !== null && lineValue !== '') {
          result.line = Number(lineValue);
        }

        if (quantityValue !== null && quantityValue !== '') {
          result.quantity = Number(quantityValue);
        }

        return result;
      }

      if (typeof init.body === 'object' && typeof init.body !== 'string') {
        result.lineKey = init.body.id ? String(init.body.id) : '';

        if (init.body.line != null && init.body.line !== '') {
          result.line = Number(init.body.line);
        }

        if (init.body.quantity != null && init.body.quantity !== '') {
          result.quantity = Number(init.body.quantity);
        }

        return result;
      }

      if (typeof init.body !== 'string') {
        return result;
      }

      const trimmedBody = init.body.trim();

      if (trimmedBody.charAt(0) === '{') {
        try {
          const parsed = JSON.parse(trimmedBody);
          result.lineKey = parsed && parsed.id ? String(parsed.id) : '';

          if (parsed && parsed.line != null && parsed.line !== '') {
            result.line = Number(parsed.line);
          }

          if (parsed && parsed.quantity != null && parsed.quantity !== '') {
            result.quantity = Number(parsed.quantity);
          }

          return result;
        } catch (parseError) {}
      }
  
      const params = new URLSearchParams(init.body);
      result.lineKey = params.get('id') || '';
  
      const lineValue = params.get('line');
      const quantityValue = params.get('quantity');

      if (lineValue !== null && lineValue !== '') {
        result.line = Number(lineValue);
      }
  
      if (quantityValue !== null && quantityValue !== '') {
        result.quantity = Number(quantityValue);
      }
  
      return result;
    };
  
    const parseCartUpdateBody = (init) => {
      if (!init || !init.body) {
        return {};
      }
  
      try {
        const parsed = typeof init.body === 'string' ? JSON.parse(init.body) : init.body;
  
        if (parsed && parsed.updates && typeof parsed.updates === 'object') {
          return parsed.updates;
        }
      } catch (parseError) {}
  
      return {};
    };
  
    const getGiftQuantityIncreaseCandidates = (requestUrl, init) => {
      const method = init && init.method ? String(init.method).toUpperCase() : 'GET';
  
      if (method !== 'POST') {
        return null;
      }
  
      const candidates = {};
  
      if (isCartChangeFetchUrl(requestUrl)) {
        const parsed = parseCartChangeBody(init);
  
        if (parsed.lineKey && parsed.quantity !== null && parsed.quantity > 1) {
          candidates[parsed.lineKey] = parsed.quantity;
        }
      } else if (isCartUpdateFetchUrl(requestUrl)) {
        const updates = parseCartUpdateBody(init);
  
        for (const lineKey of Object.keys(updates)) {
          const quantity = Number(updates[lineKey]);
  
          if (quantity > 1) {
            candidates[lineKey] = quantity;
          }
        }
      }
  
      if (Object.keys(candidates).length === 0) {
        return null;
      }
  
      return candidates;
    };
  
    const interceptGiftQuantityIncrease = (requestUrl, init) => {
      const candidates = getGiftQuantityIncreaseCandidates(requestUrl, init);
  
      if (!candidates) {
        return Promise.resolve(null);
      }
  
      const candidateKeys = Object.keys(candidates);
  
      if (hasGiftItemsInCart()) {
        const giftKeys = candidateKeys.filter((lineKey) => giftCartLineKeys.has(lineKey));
  
        if (giftKeys.length === 0) {
          return Promise.resolve(null);
        }
  
        return fetchCartJson().then((cart) => {
          refreshGiftLineKeyCache(cart);
          syncRebuyCartState(cart);
          return cart;
        });
      }
  
      return fetchCartJson().then((cart) => {
        refreshGiftLineKeyCache(cart);
  
        const giftKeys = candidateKeys.filter((lineKey) => giftCartLineKeys.has(lineKey));
  
        if (giftKeys.length === 0) {
          return null;
        }
  
        syncRebuyCartState(cart);
        return cart;
      });
    };

    const getQuantityUpdatesFromRequest = (requestUrl, init, cart) => {
      const updates = {};

      if (isCartChangeFetchUrl(requestUrl)) {
        const parsed = parseCartChangeBody(init);
        let lineKey = parsed.lineKey;

        if (!lineKey && parsed.line && cart && cart.items && cart.items[parsed.line - 1]) {
          lineKey = cart.items[parsed.line - 1].key;
        }

        if (lineKey && parsed.quantity !== null && !Number.isNaN(parsed.quantity)) {
          updates[lineKey] = parsed.quantity;
        }
      } else if (isCartUpdateFetchUrl(requestUrl)) {
        const rawUpdates = parseCartUpdateBody(init);

        for (const lineKey of Object.keys(rawUpdates)) {
          const quantity = Number(rawUpdates[lineKey]);

          if (!Number.isNaN(quantity)) {
            updates[lineKey] = quantity;
          }
        }
      }

      return updates;
    };

    const areAllQuantityUpdatesZero = (updates) => {
      const lineKeys = Object.keys(updates);

      if (lineKeys.length === 0) {
        return false;
      }

      for (const lineKey of lineKeys) {
        if (Number(updates[lineKey]) !== 0) {
          return false;
        }
      }

      return true;
    };

    const getCartItemByKey = (cart, lineKey) => {
      if (!cart || !cart.items || !lineKey) {
        return null;
      }

      for (const item of cart.items) {
        if (item.key === lineKey) {
          return item;
        }
      }

      return null;
    };

    const collectBundleKeysForMinQtyBreach = (cart, updates) => {
      const lineKeys = [];

      for (const lineKey of Object.keys(updates)) {
        const cartItem = getCartItemByKey(cart, lineKey);

        if (!shouldRemoveBundleForQuantityChange(cartItem, updates[lineKey])) {
          continue;
        }

        const groupKeys = getBundleLineKeysToRemoveForMain(cart, lineKey);

        for (const groupKey of groupKeys) {
          lineKeys.push(groupKey);
        }
      }

      return [...new Set(lineKeys)];
    };

    const getBundleKeysToRemoveForRequest = (requestUrl, init, cart) => {
      if (!cart) {
        return [];
      }

      rememberAtcMinQuantities(cart);

      const updates = getQuantityUpdatesFromRequest(requestUrl, init, cart);

      if (Object.keys(updates).length === 0) {
        return [];
      }

      if (isCartUpdateFetchUrl(requestUrl) && areAllQuantityUpdatesZero(updates)) {
        return [];
      }

      return collectBundleKeysForMinQtyBreach(cart, updates);
    };

    const interceptBundleMinQuantity = (requestUrl, init) => {
      const method = init && init.method ? String(init.method).toUpperCase() : 'GET';

      if (method !== 'POST') {
        return Promise.resolve(null);
      }

      if (!isCartChangeFetchUrl(requestUrl) && !isCartUpdateFetchUrl(requestUrl)) {
        return Promise.resolve(null);
      }

      const knownCart = getKnownCart();

      if (bundleCascadeLock) {
        if (isCartChangeFetchUrl(requestUrl)) {
          const lockedKeys = getBundleKeysToRemoveForRequest(requestUrl, init, knownCart);
          return Promise.resolve(lockedKeys.length > 0 ? buildCartWithoutKeys(knownCart, lockedKeys) : knownCart);
        }

        return Promise.resolve(null);
      }

      const removeForCart = (cart) => {
        const lineKeys = getBundleKeysToRemoveForRequest(requestUrl, init, cart);

        if (lineKeys.length === 0) {
          return null;
        }

        const optimisticCart = buildCartWithoutKeys(cart, lineKeys);
        setLastCartJson(optimisticCart);
        bundleCascadeLock = true;
        bulkRemoveCartLines(lineKeys).finally(() => {
          bundleCascadeLock = false;
        });

        return optimisticCart;
      };

      if (knownCart) {
        return Promise.resolve(removeForCart(knownCart));
      }

      return fetchCartJson().then(removeForCart);
    };

    const createBlockedGiftQuantityResponse = (cart) => {
      syncSmartCartHiddenQuantities();
  
      return new Response(JSON.stringify(cart), {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      });
    };
  
    const handleCartMutationFetchResponse = (requestUrl, response) => {
      if (isCartMutationFetchUrl(requestUrl) && response.ok && !giftQtyNormalizeLock) {
        scheduleGiftQtyNormalization();
      }
  
      if (response.ok) {
        response
          .clone()
          .json()
          .then((payload) => {
            if (payload && payload.items) {
              refreshGiftLineKeyCache(payload);
            }

            if (payload && typeof payload.item_count === 'number') {
              syncHeaderCartToggle(payload);
            }
  
            if (isCartAddFetchUrl(requestUrl) && payload && !payload.status) {
              handleMwBundleCartAddSuccess(payload);
            }
          })
          .catch(() => {});
      }
  
      return response;
    };
  
    const getGiftQtyUpdates = (cart) => {
      const updates = {};
  
      if (!cart || !cart.items) {
        return updates;
      }
  
      for (const item of cart.items) {
        if (getItemProperty(item, bundleRoleProperty) !== 'gift') {
          continue;
        }
  
        if (!item.key) {
          continue;
        }
  
        if (item.quantity > 1) {
          updates[item.key] = 1;
        }
      }
  
      return updates;
    };
  
    const normalizeGiftQuantities = (cart) => {
      if (giftQtyNormalizeLock) {
        return Promise.resolve(null);
      }
  
      const applyGiftQtyUpdates = (cartData) => {
        const updates = getGiftQtyUpdates(cartData);
        const updateKeys = Object.keys(updates);
  
        if (updateKeys.length === 0) {
          return Promise.resolve(cartData);
        }
  
        giftQtyNormalizeLock = true;
  
        return fetch(getCartUpdateUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            updates,
          }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(response.status);
            }
  
            return response.json();
          })
          .then((updatedCart) => {
            refreshGiftLineKeyCache(updatedCart);
            syncRebuyCartState(updatedCart);
            syncSmartCartHiddenQuantities();
            return updatedCart;
          })
          .catch(() => null)
          .finally(() => {
            giftQtyNormalizeLock = false;
          });
      };
  
      if (cart) {
        return applyGiftQtyUpdates(cart);
      }
  
      return fetchCartJson()
        .then(applyGiftQtyUpdates)
        .catch(() => null);
    };
  
    const scheduleGiftQtyNormalization = () => {
      if (giftQtyNormalizeTimer) {
        window.clearTimeout(giftQtyNormalizeTimer);
      }
  
      giftQtyNormalizeTimer = window.setTimeout(() => {
        giftQtyNormalizeTimer = null;
        normalizeGiftQuantities();
      }, giftQtyNormalizeDelayMs);
    };
  
    const isCartMutationFetchUrl = (url) => {
      if (!url) {
        return false;
      }
  
      const urlString = String(url);
  
      // Theme ATC often hits /cart/add (no .js); Ajax API uses /cart/add.js|.json
      return (
        isCartAddFetchUrl(urlString) ||
        /\/cart\/(change|update)\.js(\?|$)/.test(urlString)
      );
    };
  
    const isCartAddFetchUrl = (url) => {
      if (!url) {
        return false;
      }
  
      // Match /cart/add, /cart/add.js, /cart/add.json (with optional locale prefix).
      // Previously only .js was matched → duplicate ATC on bare /cart/add slipped through.
      return /\/cart\/add(?:\.js|\.json)?(\?|$)/.test(String(url));
    };
  
      const getCartAddRequestBodyInfo = (init) => {
        const info = {
          isItemsPayload: false,
          variantId: '',
          itemVariantIds: [],
          isFormPost: false,
          hasBundleRole: false,
          hasBundleKey: false,
          hasMoonbundle: false,
        };
    
        const applyLineProperties = (properties) => {
          if (!properties || typeof properties !== 'object') {
            return;
          }
    
          if (properties._bundle_role) {
            info.hasBundleRole = true;
          }
    
          if (properties._bundle_key) {
            info.hasBundleKey = true;
          }
    
          if (properties.__moonbundle) {
            info.hasMoonbundle = true;
          }
        };
    
        if (!init || !init.body) {
          return info;
        }
    
        if (typeof init.body === 'string') {
          try {
            const parsed = JSON.parse(init.body);
    
            if (parsed && Array.isArray(parsed.items)) {
              info.isItemsPayload = true;
    
              for (const line of parsed.items) {
                if (!line) {
                  continue;
                }
    
                const lineVariantId = String(line.id || line.variant_id || '');
    
                if (lineVariantId) {
                  info.itemVariantIds.push(lineVariantId);
    
                  if (!info.variantId) {
                    info.variantId = lineVariantId;
                  }
                }
    
                applyLineProperties(line.properties);
              }
    
              return info;
            }
    
            if (parsed && (parsed.id || parsed.variant_id)) {
              info.variantId = String(parsed.id || parsed.variant_id);
              applyLineProperties(parsed.properties);
            }
          } catch (parseError) {
            info.isFormPost = init.body.indexOf('form_type=') !== -1;
            const idMatch = init.body.match(/(?:^|&)id=([^&]+)/);
    
            if (idMatch) {
              info.variantId = decodeURIComponent(idMatch[1]);
            }
    
            info.hasBundleRole =
              init.body.indexOf('properties%5B_bundle_role%5D') !== -1 ||
              init.body.indexOf('properties[_bundle_role]') !== -1;
            info.hasBundleKey =
              init.body.indexOf('properties%5B_bundle_key%5D') !== -1 ||
              init.body.indexOf('properties[_bundle_key]') !== -1;
            info.hasMoonbundle =
              init.body.indexOf('properties%5B__moonbundle%5D') !== -1 ||
              init.body.indexOf('properties[__moonbundle]') !== -1;
          }
    
          return info;
        }
    
        if (init.body instanceof FormData) {
          info.isFormPost = true;
          info.variantId = String(init.body.get('id') || '');
    
          for (const entry of init.body.entries()) {
            const key = entry[0];
    
            if (key.indexOf('_bundle_role') !== -1 && entry[1]) {
              info.hasBundleRole = true;
            }
    
            if (key.indexOf('_bundle_key') !== -1 && entry[1]) {
              info.hasBundleKey = true;
            }
    
            if (key.indexOf('__moonbundle') !== -1 && entry[1]) {
              info.hasMoonbundle = true;
            }
          }
        }
    
        return info;
      };
    
      const cartAddMatchesThemeBundleGuard = (bodyInfo) => {
        if (!bodyInfo) {
          return false;
        }
    
        const guardVariantId = themeBundleAtcGuard.variantId;
    
        if (
          guardVariantId &&
          (bodyInfo.variantId === guardVariantId ||
            (bodyInfo.itemVariantIds && bodyInfo.itemVariantIds.indexOf(guardVariantId) !== -1))
        ) {
          return true;
        }
    
        // Moon / MW-tagged ATC for the same PDP click (variant id may be rewritten).
        return Boolean(bodyInfo.hasBundleKey || bodyInfo.hasBundleRole || bodyInfo.hasMoonbundle);
      };
    
      const shouldBlockThemeManagedCartAdd = (requestUrl, init) => {
        if (bundleItemsAddInFlight && isCartAddFetchUrl(requestUrl)) {
          const method = init && init.method ? String(init.method).toUpperCase() : 'GET';

          if (method !== 'POST') {
            return false;
          }

          const bodyInfo = getCartAddRequestBodyInfo(init);

          if (bodyInfo.isItemsPayload && bodyInfo.hasBundleKey) {
            return false;
          }

          return true;
        }

        if (!isThemeBundleAtcGuardActive()) {
          return false;
        }
    
        if (!isCartAddFetchUrl(requestUrl)) {
          return false;
        }
    
        const method = init && init.method ? String(init.method).toUpperCase() : 'GET';
    
        if (method !== 'POST') {
          return false;
        }
    
        const bodyInfo = getCartAddRequestBodyInfo(init);
    
        // Shadow form posts from theme/Rebuy: block only after a real add already
        // went through. Always blocking the first form returns a fake success and
        // Moonbundle never sees the request → nothing is added to the cart.
        if (bodyInfo.isFormPost) {
          return Boolean(themeBundleAtcGuard.primaryAddConsumed);
        }
    
        if (!cartAddMatchesThemeBundleGuard(bodyInfo)) {
          return false;
        }
    
        // Allow the first matching add (theme, MW builder, or Moon-expanded items[]).
        // Block every further matching add in the same window — items[] used to bypass
        // this guard entirely, which let Moon + Rebuy double-add the same offer.
        return Boolean(themeBundleAtcGuard.primaryAddConsumed);
      };
    
      const markThemeBundlePrimaryAddConsumed = (requestUrl, init) => {
        if (!isThemeBundleAtcGuardActive() || !isCartAddFetchUrl(requestUrl)) {
          return;
        }
    
        const method = init && init.method ? String(init.method).toUpperCase() : 'GET';
    
        if (method !== 'POST') {
          return;
        }
    
        const bodyInfo = getCartAddRequestBodyInfo(init);
    
        // Form ATC on the guarded PDP counts as the primary add even if the
        // variant id was rewritten (Moonbundle / MW) and no longer matches.
        if (cartAddMatchesThemeBundleGuard(bodyInfo) || bodyInfo.isFormPost) {
          themeBundleAtcGuard.primaryAddConsumed = true;
        }
      };
    
      // Rebuy / Palo Alto read /cart/add as a single line and access variant_options[0].
      const ensureVariantOptions = (item) => {
        if (!item || typeof item !== 'object') {
          return item;
        }

        if (Array.isArray(item.variant_options)) {
          return item;
        }

        if (Array.isArray(item.options)) {
          item.variant_options = item.options;
          return item;
        }

        const optionValues = [item.option1, item.option2, item.option3].filter((value) => {
          return value != null && value !== '';
        });

        item.variant_options = optionValues;
        return item;
      };

      const buildSilentCartAddLine = (bodyInfo, sourceItem) => {
        if (sourceItem && typeof sourceItem === 'object') {
          return ensureVariantOptions(Object.assign({}, sourceItem));
        }

        return {
          id: bodyInfo.variantId || themeBundleAtcGuard.variantId || 0,
          variant_id: bodyInfo.variantId || themeBundleAtcGuard.variantId || 0,
          quantity: 0,
          properties: {},
          key: 'theme-blocked-duplicate',
          variant_options: [],
        };
      };

      // Palo Alto treats /cart/add as a single line (`id`, `key`, `variant_options`).
      // A multi-item `{ items: [...] }` (Moonbundle) has no root `id` → the theme
      // takes the error path and prints `response.description` which is undefined.
      const liftCartAddLineToRoot = (payload) => {
        if (!payload || typeof payload !== 'object') {
          return payload;
        }

        if (payload.status && payload.status !== 200) {
          if (payload.description == null && payload.message) {
            payload.description = String(payload.message);
          }

          if (payload.description == null) {
            payload.description = '';
          }

          return payload;
        }

        const firstItem =
          Array.isArray(payload.items) && payload.items[0] && typeof payload.items[0] === 'object'
            ? payload.items[0]
            : null;

        if (firstItem) {
          const itemKeys = Object.keys(firstItem);

          for (let i = 0; i < itemKeys.length; i++) {
            const itemKey = itemKeys[i];

            if (payload[itemKey] === undefined) {
              payload[itemKey] = firstItem[itemKey];
            }
          }

          for (let i = 0; i < payload.items.length; i++) {
            ensureVariantOptions(payload.items[i]);
          }
        }

        ensureVariantOptions(payload);

        if (payload.id == null && payload.variant_id != null) {
          payload.id = payload.variant_id;
        }

        if (!payload.key) {
          payload.key = payload.id ? String(payload.id) : 'theme-cart-add';
        }

        // Palo Alto: `if (response.status) show(response.description)`.
        // A leftover status (or HTTP 200 copied onto JSON) prints "undefined".
        delete payload.status;

        return payload;
      };

      const hideUndefinedProductFormErrors = () => {
        const containers = document.querySelectorAll('[data-cart-errors-container].is-visible');

        for (let i = 0; i < containers.length; i++) {
          const container = containers[i];
          const errorNode = container.querySelector('[data-error]') || container;
          const text = String(errorNode.textContent || '').replace(/\s+/g, ' ').trim();

          if (text === 'undefined' || text === 'null' || text === '') {
            container.classList.remove('is-visible');
            container.hidden = true;
          }
        }
      };

      const normalizeCartAddFetchResponse = (requestUrl, response) => {
        if (!isCartAddFetchUrl(requestUrl) || !response) {
          return Promise.resolve(response);
        }

        return response
          .clone()
          .json()
          .then((payload) => {
            if (!payload || typeof payload !== 'object') {
              return response;
            }

            const normalized = liftCartAddLineToRoot(payload);
            const httpStatus =
              response.ok || !normalized.status ? 200 : response.status;

            return new Response(JSON.stringify(normalized), {
              status: httpStatus,
              statusText: response.statusText,
              headers: {
                'Content-Type': 'application/json',
              },
            });
          })
          .catch(() => response);
      };

      // Silent no-op for duplicate ATC: look like a successful /cart/add so the theme
      // does not toast `status` / `description` (do not return Shopify-style 422 JSON).
      const createSilentDuplicateCartAddResponse = (init) => {
        const bodyInfo = getCartAddRequestBodyInfo(init);
    
        return fetchCartJson()
          .then((cart) => {
            syncRebuyCartState(cart);
    
            const items = Array.isArray(cart && cart.items) ? cart.items : [];
            const wantedIds = new Set(
              (bodyInfo.itemVariantIds && bodyInfo.itemVariantIds.length
                ? bodyInfo.itemVariantIds
                : bodyInfo.variantId
                  ? [bodyInfo.variantId]
                  : themeBundleAtcGuard.variantId
                    ? [themeBundleAtcGuard.variantId]
                    : []
              ).map(String)
            );
    
            const matchedItems = wantedIds.size
              ? items.filter((item) => wantedIds.has(String(item.variant_id || item.id)))
              : items.slice(0, 1);
            const sourceItems = matchedItems.length ? matchedItems : items;
            const line = buildSilentCartAddLine(bodyInfo, sourceItems[0]);

            // Keep items[] when the caller posted {items}, but always lift a line
            // to the root so Rebuy / Palo Alto can read id + variant_options[0].
            const payload = liftCartAddLineToRoot(
              bodyInfo.isItemsPayload
                ? Object.assign({ items: sourceItems.map((item) => ensureVariantOptions(Object.assign({}, item))) }, line)
                : line
            );
    
            return new Response(JSON.stringify(payload), {
              status: 200,
              headers: {
                'Content-Type': 'application/json',
              },
            });
          })
          .catch(() => {
            return new Response(JSON.stringify(liftCartAddLineToRoot(buildSilentCartAddLine(bodyInfo, null))), {
              status: 200,
              headers: {
                'Content-Type': 'application/json',
              },
            });
          });
      };
    
      const patchCartFetchForGiftQty = () => {
        if (window.fetchGiftQtyPatched || typeof window.fetch !== 'function') {
          return;
        }
    
        const originalFetch = window.fetch.bind(window);
    
        window.fetch = function(input, init) {
          const requestUrl = typeof input === 'string' ? input : (input && input.url ? input.url : '');
    
          if (shouldBlockThemeManagedCartAdd(requestUrl, init)) {
            return createSilentDuplicateCartAddResponse(init).then((response) => {
              window.setTimeout(hideUndefinedProductFormErrors, 0);
              return response;
            });
          }
    
          markThemeBundlePrimaryAddConsumed(requestUrl, init);
    
          if (isCartChangeFetchUrl(requestUrl) || isCartUpdateFetchUrl(requestUrl)) {
            return interceptGiftQuantityIncrease(requestUrl, init).then((blockedCart) => {
              if (blockedCart) {
                return createBlockedGiftQuantityResponse(blockedCart);
              }

              return interceptBundleMinQuantity(requestUrl, init).then((removedCart) => {
                if (removedCart) {
                  return createBlockedGiftQuantityResponse(removedCart);
                }
    
                return originalFetch(input, init).then((response) => {
                  return handleCartMutationFetchResponse(requestUrl, response);
                });
              });
            });
          }

          if (isCartAddFetchUrl(requestUrl)) {
            return originalFetch(input, init)
              .then((response) => {
                return normalizeCartAddFetchResponse(requestUrl, response).then((normalized) => {
                  window.setTimeout(hideUndefinedProductFormErrors, 0);
                  return handleCartMutationFetchResponse(requestUrl, normalized);
                });
              })
              .catch((error) => {
                // Inner wrapper (Rebuy) may throw on a multi-item add after Shopify
                // already accepted it. Return a valid line so Palo Alto does not
                // print `undefined` in [data-cart-errors-container].
                if (isThemeBundleAtcGuardActive()) {
                  window.setTimeout(hideUndefinedProductFormErrors, 0);
                  return createSilentDuplicateCartAddResponse(init);
                }

                throw error;
              });
          }

          return originalFetch(input, init).then((response) => {
            return handleCartMutationFetchResponse(requestUrl, response);
          });
        };
    
        window.fetchGiftQtyPatched = true;
      };

      const completeXhrWithCart = (xhr, cart) => {
        const payload = cart || { items: [], item_count: 0 };
        const body = JSON.stringify(payload);

        try {
          Object.defineProperty(xhr, 'readyState', { configurable: true, get: function() { return 4; } });
          Object.defineProperty(xhr, 'status', { configurable: true, get: function() { return 200; } });
          Object.defineProperty(xhr, 'responseText', { configurable: true, get: function() { return body; } });
          Object.defineProperty(xhr, 'response', {
            configurable: true,
            get: function() {
              return xhr.responseType === 'json' ? payload : body;
            },
          });
        } catch (defineError) {}

        if (typeof xhr.onreadystatechange === 'function') {
          xhr.onreadystatechange();
        }

        if (typeof xhr.onload === 'function') {
          xhr.onload();
        }

        try {
          xhr.dispatchEvent(new Event('readystatechange'));
          xhr.dispatchEvent(new Event('load'));
          xhr.dispatchEvent(new Event('loadend'));
        } catch (dispatchError) {}
      };

      const patchCartXhrForBundleMinQty = () => {
        if (window.xhrBundleMinQtyPatched || typeof window.XMLHttpRequest !== 'function') {
          return;
        }

        const originalOpen = XMLHttpRequest.prototype.open;
        const originalSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function(method, url) {
          this._bundleCartMethod = method;
          this._bundleCartUrl = url ? String(url) : '';
          return originalOpen.apply(this, arguments);
        };

        XMLHttpRequest.prototype.send = function(body) {
          const requestUrl = this._bundleCartUrl || '';
          const method = this._bundleCartMethod || 'GET';
          const init = {
            method: method,
            body: body,
          };

          if ((isCartChangeFetchUrl(requestUrl) || isCartUpdateFetchUrl(requestUrl)) && String(method).toUpperCase() === 'POST') {
            const knownCart = getKnownCart();
            const lineKeys = getBundleKeysToRemoveForRequest(requestUrl, init, knownCart);

            if (bundleCascadeLock && isCartChangeFetchUrl(requestUrl)) {
              completeXhrWithCart(this, lineKeys.length > 0 ? buildCartWithoutKeys(knownCart, lineKeys) : knownCart);
              return;
            }

            if (!bundleCascadeLock && lineKeys.length > 0) {
              const optimisticCart = buildCartWithoutKeys(knownCart, lineKeys);
              setLastCartJson(optimisticCart);
              bundleCascadeLock = true;
              bulkRemoveCartLines(lineKeys).finally(() => {
                bundleCascadeLock = false;
              });
              completeXhrWithCart(this, optimisticCart);
              return;
            }
          }

          return originalSend.apply(this, arguments);
        };

        window.xhrBundleMinQtyPatched = true;
      };
  
    const cleanupOrphanBundleGifts = () => {
      if (bundleCascadeLock) {
        return Promise.resolve();
      }
  
      bundleCascadeLock = true;
  
      return fetchCartJson()
        .then((cart) => {
          const lineKeys = getOrphanGiftLineKeys(cart);
  
          if (lineKeys.length === 0) {
            return null;
          }
  
          return bulkRemoveCartLines(lineKeys);
        })
        .catch(() => {})
        .finally(() => {
          bundleCascadeLock = false;
          syncSmartCartHiddenQuantities();
        });
    };
  
    const scheduleOrphanBundleGiftCleanup = () => {
      if (bundleCascadeLock) {
        return;
      }
  
      if (orphanCleanupTimer) {
        window.clearTimeout(orphanCleanupTimer);
      }
  
      orphanCleanupTimer = window.setTimeout(() => {
        orphanCleanupTimer = null;
        cleanupOrphanBundleGifts();
      }, orphanCleanupDelayMs);
    };
  
    const getVisibleSmartCartItems = (smartCart) => {
      if (!smartCart || typeof smartCart.items !== 'function') {
        return [];
      }
  
      const items = smartCart.items();
  
      if (!Array.isArray(items)) {
        return [];
      }
  
      const visibleItems = [];
  
      for (const item of items) {
        if (typeof smartCart.isHiddenItem === 'function' && smartCart.isHiddenItem(item)) {
          continue;
        }
  
        visibleItems.push(item);
      }
  
      return visibleItems;
    };
  
      const activateThemeBundleAtcGuard = (detail) => {
        if (!detail || !detail.variantId) {
          return;
        }
    
        themeBundleAtcGuard = {
          active: true,
          variantId: String(detail.variantId),
          productId: detail.productId ? String(detail.productId) : '',
          expiresAt: Date.now() + themeAtcGuardMs,
          primaryAddConsumed: false,
        };
      };
  
    const isThemeBundleAtcGuardActive = () => {
      if (!themeBundleAtcGuard.active) {
        return false;
      }
  
      if (Date.now() > themeBundleAtcGuard.expiresAt) {
        themeBundleAtcGuard.active = false;
        return false;
      }
  
      return true;
    };
  
    const isRebuyPlainDuplicateAdd = (item) => {
      if (!item || !isThemeBundleAtcGuardActive()) {
        return false;
      }
  
      const variantId = String(item.variant_id || item.id || '');
  
      // Same variant as the guarded ATC — cleanup removes the extra line when
      // another bundled main already exists (see handleRebuyDuplicateAdd).
      if (variantId && variantId === themeBundleAtcGuard.variantId) {
        return true;
      }
  
      const bundleKey = getItemProperty(item, '_bundle_key');
  
      if (bundleKey) {
        return true;
      }
  
      return Boolean(getItemProperty(item, '__moonbundle'));
    };
  
    const shouldBlockRebuyAddItem = (data) => {
      if (!data || !isThemeBundleAtcGuardActive()) {
        return false;
      }
  
      const properties = data.properties || {};
      const hasBundleKey = Boolean(properties._bundle_key);
      const hasMoonbundle = Boolean(properties.__moonbundle);
      const incomingVariantId = String(data.id || data.variant_id || '');
  
      // Legitimate MW builder ATC uses fetch(/cart/add.js) directly, never Rebuy.addItem.
      // Do not whitelist _bundle_role here — Moon + form props made Rebuy duplicates
      // look "official" and bypassed the guard.
      if (incomingVariantId && incomingVariantId === themeBundleAtcGuard.variantId) {
        return true;
      }
  
      if (hasBundleKey || hasMoonbundle) {
        return true;
      }
  
      return false;
    };
  
    const getSmartCartItemForElement = (itemElement) => {
      const smartCart = getSmartCart();
  
      if (!smartCart || !itemElement) {
        return null;
      }
  
      const items = getVisibleSmartCartItems(smartCart);
      const dataKey = itemElement.getAttribute('data-key') || itemElement.getAttribute('data-line-item-key');

      if (dataKey) {
        for (const item of items) {
          if (item.key === dataKey) {
            return item;
          }
        }
      }

      const className = typeof itemElement.className === 'string' ? itemElement.className : '';
      const variantClassMatch = className.match(/variant-id-(\d+)/);

      if (variantClassMatch) {
        const variantMatches = [];

        for (const item of items) {
          if (String(item.variant_id) === variantClassMatch[1]) {
            variantMatches.push(item);
          }
        }

        if (variantMatches.length === 1) {
          return variantMatches[0];
        }
      }

      const itemElements = document.querySelectorAll('#rebuy-cart .rebuy-cart__flyout-item');
  
      for (let index = 0; index < itemElements.length; index += 1) {
        if (itemElements[index] === itemElement) {
          return items[index] || null;
        }
      }
  
      return null;
    };
  
    const setRemoveButtonLoading = (removeButton, isLoading) => {
      if (!removeButton || !removeButton.isConnected) {
        return;
      }
  
      if (isLoading) {
        if (!removeButton.dataset.originalIconMarkup) {
          removeButton.dataset.originalIconMarkup = removeButton.innerHTML;
        }
  
        removeButton.classList.add(removeButtonLoadingClass);
        removeButton.setAttribute('disabled', 'disabled');
        removeButton.setAttribute('aria-busy', 'true');
        removeButton.innerHTML = removeLoaderMarkup;
        return;
      }
  
      removeButton.classList.remove(removeButtonLoadingClass);
      removeButton.removeAttribute('disabled');
      removeButton.removeAttribute('aria-busy');
  
      if (removeButton.dataset.originalIconMarkup) {
        removeButton.innerHTML = removeButton.dataset.originalIconMarkup;
        delete removeButton.dataset.originalIconMarkup;
      }
    };
  
    const removeSubscribeBundleForMatchedItem = (matchedItem, loadingButton) => {
      if (bundleCascadeLock) {
        return;
      }

      const startRemove = (cart) => {
        rememberAtcMinQuantities(cart);
        const lineKey = resolveShopifyLineKey(cart, matchedItem);
        const lineKeys = getBundleLineKeysToRemoveForMain(cart, lineKey);

        if (!lineKey || lineKeys.length === 0) {
          return Promise.resolve(null);
        }

        const optimisticCart = buildCartWithoutKeys(cart, lineKeys);
        setLastCartJson(optimisticCart);
        syncRebuyCartState(optimisticCart);
        bundleCascadeLock = true;

        if (loadingButton) {
          setRemoveButtonLoading(loadingButton, true);
        }

        return bulkRemoveCartLines(lineKeys)
          .catch(() => {})
          .finally(() => {
            bundleCascadeLock = false;

            if (loadingButton) {
              setRemoveButtonLoading(loadingButton, false);
            }

            syncSmartCartHiddenQuantities();
            scheduleOrphanBundleGiftCleanup();
          });
      };

      const knownCart = getKnownCart();

      if (knownCart) {
        startRemove(knownCart);
        return;
      }

      fetchCartJson()
        .then(startRemove)
        .catch(() => {});
    };

    const isSubscribeBundleMainFromElement = (itemElement, matchedItem) => {
      if (!itemElement || !matchedItem) {
        return false;
      }

      if (itemElement.classList.contains('property-_bundle_role:gift')) {
        return false;
      }

      const elementProperties = getRebuyElementProperties(itemElement);
      const purchaseMode = getPurchaseModeFromItem(matchedItem) || elementProperties._purchase_mode || '';

      if (purchaseMode === 'otp' || isOtpBundleMainItem(matchedItem)) {
        return false;
      }

      if (isSubscribeBundleQtyProtectedItem(matchedItem)) {
        return true;
      }

      const bundleRole = getItemProperty(matchedItem, bundleRoleProperty) || elementProperties._bundle_role || '';
      const bundleProductId = getBundleProductIdFromItem(matchedItem) || elementProperties._bundle_product_id || '';

      return bundleRole === 'main' && Boolean(bundleProductId);
    };

    const isSmartCartQuantityDecreaseTarget = (eventTarget, itemElement) => {
      if (!eventTarget || !itemElement) {
        return false;
      }

      const quantityContainer = eventTarget.closest('.rebuy-cart__flyout-item-quantity');

      if (!quantityContainer || !itemElement.contains(quantityContainer)) {
        return false;
      }

      if (eventTarget.closest('[aria-label*="Increase" i], [aria-label*="increase" i], [class*="plus"], [data-action="increase"]')) {
        return false;
      }

      if (eventTarget.closest('[aria-label*="Decrease" i], [aria-label*="decrease" i], [class*="minus"], [data-action="decrease"]')) {
        return true;
      }

      const buttons = quantityContainer.querySelectorAll('button, [role="button"], .rebuy-cart__flyout-item-quantity-widget-button');

      if (buttons.length === 0) {
        return false;
      }

      return buttons[0] === eventTarget || buttons[0].contains(eventTarget);
    };

    const handleSmartCartRemoveClick = (event) => {
      const removeButton = event.target.closest('#rebuy-cart .rebuy-cart__flyout-item-remove');
  
      if (!removeButton || bundleCascadeLock) {
        return;
      }
  
      const itemElement = removeButton.closest('.rebuy-cart__flyout-item');
  
      if (!itemElement) {
        return;
      }
  
      if (itemElement.classList.contains('property-_bundle_role:gift')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
  
      const matchedItem = getSmartCartItemForElement(itemElement);
  
      if (!isSubscribeBundleMainFromElement(itemElement, matchedItem)) {
        return;
      }
  
      event.preventDefault();
      event.stopImmediatePropagation();
      removeSubscribeBundleForMatchedItem(matchedItem, removeButton);
    };

    const handleSmartCartQuantityClick = (event) => {
      const itemElement = event.target.closest('#rebuy-cart .rebuy-cart__flyout-item');

      if (!itemElement || bundleCascadeLock) {
        return;
      }

      if (!isSmartCartQuantityDecreaseTarget(event.target, itemElement)) {
        return;
      }

      const matchedItem = getSmartCartItemForElement(itemElement);

      if (!isSubscribeBundleMainFromElement(itemElement, matchedItem)) {
        return;
      }

      const currentQty = Number(matchedItem.quantity) || 1;
      const minQty = getAtcMinQtyFromItem(matchedItem);

      if (currentQty > minQty) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      removeSubscribeBundleForMatchedItem(matchedItem, null);
    };
  
    const patchSmartCartRemoveButtons = () => {
      if (document.body.smartCartRemovePatched) {
        return;
      }
  
      document.body.addEventListener('click', handleSmartCartRemoveClick, true);
      document.body.addEventListener('pointerdown', handleSmartCartQuantityClick, true);
      document.body.addEventListener('mousedown', handleSmartCartQuantityClick, true);
      document.body.addEventListener('click', handleSmartCartQuantityClick, true);
      document.body.smartCartRemovePatched = true;
    };
  
    const handleSmartCartBundleRemoval = (event) => {
      syncHeaderCartToggleFromEvent(event);

      if (bundleCascadeLock) {
        return;
      }
  
      scheduleOrphanBundleGiftCleanup();
    };
  
    const handleSmartCartCartChange = (event) => {
      syncHeaderCartToggleFromEvent(event);

      if (bundleCascadeLock) {
        return;
      }
  
      scheduleOrphanBundleGiftCleanup();
    };
  
    const handleRebuyDuplicateAdd = (event) => {
      const item = event.detail && event.detail.item;
  
      if (!item || !item.key) {
        return;
      }
  
      if (!isRebuyPlainDuplicateAdd(item)) {
        return;
      }
  
      fetchCartJson()
        .then((cart) => {
          const variantId = String(item.variant_id);
          const cartLine = cart.items.find((cartItem) => cartItem.key === item.key);
  
          if (cartLine && getItemProperty(cartLine, bundleRoleProperty) === 'main') {
            return null;
          }
  
          const hasOtherBundledMain = cart.items.some((cartItem) => {
            return (
              String(cartItem.variant_id) === variantId &&
              getItemProperty(cartItem, bundleRoleProperty) === 'main' &&
              cartItem.key !== item.key
            );
          });
  
          if (hasOtherBundledMain) {
            return bulkRemoveCartLines([item.key]);
          }
  
          return null;
        })
        .catch(() => {});
    };
  
    const patchRebuyCartAddItem = () => {
      const rebuyCart = window.Rebuy && window.Rebuy.Cart;
  
      if (!rebuyCart || rebuyCart.addItemPatched || typeof rebuyCart.addItem !== 'function') {
        return Boolean(rebuyCart);
      }
  
      const originalAddItem = rebuyCart.addItem.bind(rebuyCart);
  
      rebuyCart.addItem = function(data, options) {
        if (shouldBlockRebuyAddItem(data)) {
          // Do not call options.error — Rebuy/theme would surface it in the UI.
          if (options && typeof options.success === 'function') {
            fetchCartJson()
              .then((cart) => {
                syncRebuyCartState(cart);
                options.success(cart);
              })
              .catch(() => {});
          }
  
          return;
        }
  
        return originalAddItem(data, options);
      };
  
      rebuyCart.addItemPatched = true;
  
      return true;
    };
  
    const getThemeManagedProductForms = () => {
      const managedForms = new Set();
      const selectors = [
        'product-form[data-theme-managed-atc="true"] form[data-product-form]',
        'product-form[data-has-new-subscription-picker="true"] form[data-product-form]',
        'product-form[data-has-bundle-builder="true"] form[data-product-form]',
        'product-form:has([data-supply-picker]) form[data-product-form]',
        'product-form[data-has-bundle-builder="true"] form[data-product-form]:has([data-bundle-key-input])',
        'form[data-product-form][data-rebuy-disable="true"]',
      ];
  
      for (const selector of selectors) {
        const matches = document.querySelectorAll(selector);
  
        for (const form of matches) {
          managedForms.add(form);
        }
      }
  
      return Array.from(managedForms);
    };
  
    const disableRebuyProductFormHandler = () => {
      const managedForms = getThemeManagedProductForms();

      for (const form of managedForms) {
        form.setAttribute('data-rebuy-disable', 'true');
      }

      return managedForms.length > 0;
    };
  
    const patchSmartCartQuantityMethod = () => {
      const smartCart = getSmartCart();
  
      if (!smartCart || smartCart.hideQuantitySelectorsPatched) {
        return Boolean(smartCart);
      }
  
      const originalHideQuantitySelectors = smartCart.hideQuantitySelectors;
  
      smartCart.hideQuantitySelectors = function(item) {
        if (hasHiddenQuantityProperty(item)) {
          return true;
        }
  
        if (item && item.properties && item.properties._bundle_role === 'gift') {
          return true;
        }
  
        if (typeof originalHideQuantitySelectors === 'function') {
          return originalHideQuantitySelectors.call(smartCart, item);
        }
  
        return false;
      };
  
      smartCart.hideQuantitySelectorsPatched = true;
  
      return true;
    };
  
    const getRebuyItemCompareCents = (item) => {
      if (!item) {
        return 0;
      }

      if (item.compare_at_price !== undefined && item.compare_at_price !== null) {
        return Number(item.compare_at_price) || 0;
      }

      if (item.original_price !== undefined && item.original_price !== null) {
        return Number(item.original_price) || 0;
      }

      if (item.original_line_price !== undefined && item.original_line_price !== null && item.quantity) {
        return Number(item.original_line_price) / Number(item.quantity) || 0;
      }

      return 0;
    };

    const formatRebuyMoney = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        const format = window.theme && window.theme.moneyFormat
          ? window.theme.moneyFormat
          : window.Shopify.money_format;
        return String(window.Shopify.formatMoney(cents, format)).replace(/[A-Za-z]{2,}/g, '').replace(/\s+/g, ' ').trim();
      }

      return '$' + (Number(cents) / 100).toFixed(2);
    };

    const setRebuyMoneyNodeText = (moneyNode, text) => {
      if (!moneyNode) {
        return;
      }

      const spans = moneyNode.querySelectorAll('span');

      if (spans && spans.length > 0) {
        spans[spans.length - 1].textContent = text;
        return;
      }

      moneyNode.textContent = text;
    };

    const hideRebuyGiftComparePrices = () => {
      const smartCart = getSmartCart();

      if (!smartCart) {
        return;
      }

      const items = getVisibleSmartCartItems(smartCart);
      const itemElements = document.querySelectorAll('#rebuy-cart .rebuy-cart__flyout-item');
      let paidCompareCents = 0;
      let paidFinalCents = 0;

      for (let index = 0; index < itemElements.length; index += 1) {
        const item = items[index];
        const itemElement = itemElements[index];

        if (!item || !itemElement) {
          continue;
        }

        const compareNode = itemElement.querySelector('.rebuy-money.compare-at, .compare-at');
        const isGift = isBundleGiftItem(item);
        const unitPriceCents = getRebuyItemUnitPriceCents(item);
        const qty = Number(item.quantity) || 1;

        if (isGift || unitPriceCents === 0) {
          if (compareNode) {
            compareNode.hidden = true;
            compareNode.style.display = 'none';
          }

          continue;
        }

        if (compareNode) {
          compareNode.hidden = false;
          compareNode.style.display = '';
        }

        const compareUnit = getRebuyItemCompareCents(item);
        const finalUnit = unitPriceCents || 0;
        paidCompareCents += (compareUnit > finalUnit ? compareUnit : finalUnit) * qty;
        paidFinalCents += finalUnit * qty;
      }

      const subtotalCompare = document.querySelector(
        '#rebuy-cart .rebuy-cart__flyout-subtotal .rebuy-money.compare-at, #rebuy-cart .rebuy-cart__flyout-subtotals .rebuy-money.compare-at'
      );

      if (!subtotalCompare) {
        return;
      }

      if (paidCompareCents > paidFinalCents) {
        setRebuyMoneyNodeText(subtotalCompare, formatRebuyMoney(paidCompareCents));
        subtotalCompare.hidden = false;
        subtotalCompare.style.display = '';
      } else {
        subtotalCompare.hidden = true;
        subtotalCompare.style.display = 'none';
      }
    };

    const getRebuyItemUnitPriceCents = (item) => {
      if (!item) {
        return null;
      }
  
      if (item.final_price !== undefined && item.final_price !== null) {
        return Number(item.final_price);
      }
  
      if (item.price !== undefined && item.price !== null) {
        return Number(item.price);
      }
  
      if (item.line_price !== undefined && item.line_price !== null && item.quantity) {
        return Number(item.line_price) / Number(item.quantity);
      }
  
      return null;
    };
  
    const isZeroPriceDisplayText = (text) => {
      if (!text) {
        return false;
      }
  
      const normalized = String(text).trim();
  
      if (normalized === 'FREE') {
        return true;
      }
  
      return /\$0(?:\.00)?(?:\s|$)/.test(normalized) || normalized === '0' || normalized.indexOf('0.00') === 0;
    };
  
    const getRebuyItemPrimaryPriceTextNode = (itemElement) => {
      if (!itemElement) {
        return null;
      }
  
      const priceContainer = itemElement.querySelector('.rebuy-cart__flyout-item-price');
  
      if (!priceContainer) {
        return null;
      }
  
      const moneyNode = priceContainer.querySelector('.rebuy-money:not(.compare-at)');
  
      if (!moneyNode) {
        return null;
      }
  
      const spans = moneyNode.querySelectorAll('span');
  
      if (!spans || spans.length === 0) {
        return null;
      }
  
      return spans[spans.length - 1];
    };

    const bundleHasSubscribedMain = (items, bundleKey) => {
      if (!bundleKey || !items) {
        return false;
      }

      for (const item of items) {
        if (getItemProperty(item, '_bundle_key') !== bundleKey) {
          continue;
        }

        if (isSubscribeMainItem(item)) {
          return true;
        }
      }

      return false;
    };

    const getGiftInclusionNoteText = (item, allItems) => {
      const context = getItemProperty(item, '_gift_context');

      if (context === 'otp') {
        return 'Included with your order';
      }

      if (context === 'subscribe') {
        return 'Included with your subscription';
      }

      const bundleKey = getItemProperty(item, '_bundle_key');
      if (bundleHasSubscribedMain(allItems, bundleKey) || itemHasSellingPlan(item)) {
        return 'Included with your subscription';
      }

      return 'Included with your order';
    };

    const renderRebuySubscriptionGiftLabels = () => {
      const smartCart = getSmartCart();
      const items = getVisibleSmartCartItems(smartCart);
      const itemElements = document.querySelectorAll('#rebuy-cart .rebuy-cart__flyout-item');

      for (let index = 0; index < itemElements.length; index += 1) {
        const item = items[index];
        const itemElement = itemElements[index];

        if (!item || !isBundleGiftItem(item) || !itemElement) {
          continue;
        }

        const infoBlock = itemElement.querySelector('.rebuy-cart__flyout-item-info');
        if (!infoBlock) {
          continue;
        }

        const noteText = getGiftInclusionNoteText(item, items);
        let note = infoBlock.querySelector('.rebuy-subscription-gift-note');

        if (!note) {
          note = document.createElement('p');
          note.className = 'rebuy-subscription-gift-note';
          infoBlock.appendChild(note);
        }

        if (note.textContent !== noteText) {
          note.textContent = noteText;
        }
      }
    };
  
    const renderRebuyFreePrices = () => {
      const smartCart = getSmartCart();
  
      if (!smartCart) {
        return;
      }
  
      const items = getVisibleSmartCartItems(smartCart);
      const itemElements = document.querySelectorAll('#rebuy-cart .rebuy-cart__flyout-item');
  
      for (let index = 0; index < itemElements.length; index += 1) {
        const item = items[index];
        const itemElement = itemElements[index];
        const priceTextNode = getRebuyItemPrimaryPriceTextNode(itemElement);
  
        if (!priceTextNode) {
          continue;
        }
  
        const unitPriceCents = getRebuyItemUnitPriceCents(item);
        const isZeroPrice = unitPriceCents === 0 || isZeroPriceDisplayText(priceTextNode.textContent);
  
        if (isZeroPrice) {
          if (!priceTextNode.dataset.originalPriceText) {
            priceTextNode.dataset.originalPriceText = priceTextNode.textContent;
          }
  
          if (priceTextNode.textContent !== 'FREE') {
            priceTextNode.textContent = 'FREE';
          }
  
          continue;
        }
  
        if (priceTextNode.dataset.originalPriceText) {
          priceTextNode.textContent = priceTextNode.dataset.originalPriceText;
          delete priceTextNode.dataset.originalPriceText;
        }
      }
    };
  
    const renderLockedSmartCartQuantities = () => {
      const smartCart = getSmartCart();
  
      if (!smartCart) {
        return;
      }
  
      const items = getVisibleSmartCartItems(smartCart);
      const itemElements = document.querySelectorAll('.rebuy-cart__flyout-item');
  
      for (let index = 0; index < itemElements.length; index += 1) {
        const item = items[index];
        const itemElement = itemElements[index];
        const quantityContainer = itemElement.querySelector('.rebuy-cart__flyout-item-quantity');
  
        if (!quantityContainer || (!hasHiddenQuantityProperty(item) && !isBundleGiftItem(item))) {
          continue;
        }
  
        const quantityWidget = quantityContainer.querySelector('.rebuy-cart__flyout-item-quantity-widget');
  
        if (quantityWidget) {
          quantityWidget.hidden = true;
        }
  
        let lockedQuantity = quantityContainer.querySelector('.' + lockedQuantityClass);
  
        if (!lockedQuantity) {
          lockedQuantity = document.createElement('span');
          lockedQuantity.className = lockedQuantityClass;
          quantityContainer.appendChild(lockedQuantity);
        }
  
        const lockedQuantityText = 'Qty: ' + item.quantity;
  
        if (lockedQuantity.textContent !== lockedQuantityText) {
          lockedQuantity.textContent = lockedQuantityText;
        }
      }
    };
  
    const syncSmartCartHiddenQuantities = () => {
      patchRebuyCartAddItem();
      patchSmartCartRemoveButtons();
      disableRebuyProductFormHandler();
      patchThemeCartDrawerForRebuy();
      patchSmartCartQuantityMethod();
      renderLockedSmartCartQuantities();
      renderRebuyFreePrices();
      hideRebuyGiftComparePrices();
      renderRebuySubscriptionGiftLabels();
    };
  
    const watchForSmartCart = () => {
      let attempts = 0;
      const maxAttempts = 40;
  
      const interval = window.setInterval(() => {
        attempts += 1;
        syncSmartCartHiddenQuantities();
  
        if (getSmartCart() || attempts >= maxAttempts) {
          window.clearInterval(interval);
        }
      }, 250);
    };
  
    document.addEventListener('theme:bundle-atc:start', (event) => {
      activateThemeBundleAtcGuard(event.detail || {});
    });
  
    const getBundleFormFromElement = (element) => {
      if (!element) {
        return null;
      }
  
      const form = element.closest('form[data-product-form]');
  
      if (!form || !form.querySelector('[data-bundle-key-input]')) {
        return null;
      }
  
      return form;
    };
  
    const getVariantIdFromBundleForm = (form) => {
      if (!form) {
        return '';
      }
  
      const idInput = form.querySelector('[name="id"]');
  
      if (idInput && idInput.value) {
        return String(idInput.value);
      }
  
      return '';
    };
  
    const getProductIdFromBundleForm = (form) => {
      if (!form) {
        return '';
      }
  
      const productForm = form.closest('product-form');
  
      if (productForm && productForm.dataset.productId) {
        return String(productForm.dataset.productId);
      }
  
      const productInfo = form.closest('product-info');
  
      if (productInfo && productInfo.dataset.productId) {
        return String(productInfo.dataset.productId);
      }
  
      return '';
    };
  
    const handleBundleFormQuantityInteraction = (event) => {
      const target = event.target;
  
      if (!target || !target.matches || !target.matches('[data-quantity-field], [name="quantity"]')) {
        return;
      }
  
      if (!getBundleFormFromElement(target)) {
        return;
      }
  
      disableRebuyProductFormHandler();
      patchRebuyCartAddItem();
    };
  
    const handleBundleAtcClickCapture = (event) => {
      const atcButton = event.target.closest('[data-add-to-cart], [data-atc-subscription], [data-atc-otp]');
  
      if (!atcButton) {
        return;
      }
  
      const form = getBundleFormFromElement(atcButton);
  
      if (!form) {
        return;
      }
  
      disableRebuyProductFormHandler();
      patchRebuyCartAddItem();
      activateThemeBundleAtcGuard({
        variantId: getVariantIdFromBundleForm(form),
        productId: getProductIdFromBundleForm(form),
      });
    };
  
    document.addEventListener('change', handleBundleFormQuantityInteraction, true);
    document.addEventListener('input', handleBundleFormQuantityInteraction, true);
    document.addEventListener('click', handleBundleAtcClickCapture, true);
  
    const getBundleProductIdFromForm = (productForm) => {
      if (productForm.dataset.productId) {
        return String(productForm.dataset.productId);
      }
  
      const productInfo = productForm.closest('product-info');
      if (productInfo && productInfo.dataset.productId) {
        return String(productInfo.dataset.productId);
      }
  
      return '';
    };
  
    const createBundleKey = (productForm) => {
      const bundleKeyInput = productForm.querySelector('[data-bundle-key-input]');
      const bundleKey = 'pdp-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
  
      if (bundleKeyInput) {
        bundleKeyInput.value = bundleKey;
      }
  
      return bundleKey;
    };
  
    const isOtpPurchaseMode = (picker, productForm) => {
      if (picker && picker.dataset.purchaseMode === 'otp') {
        return true;
      }

      if (productForm) {
        const atcButton = productForm.querySelector('[data-atc-subscription]');
        if (atcButton && atcButton.getAttribute('data-purchase-submit') === 'otp') {
          return true;
        }
      }

      return false;
    };

    const isGiftNodeAvailable = (giftNode) => {
      if (giftNode.getAttribute('data-gift-available') === 'false') {
        return false;
      }

      const select = giftNode.querySelector('[data-gift-variant-select]');
      if (select && select.selectedIndex >= 0) {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.getAttribute('data-gift-available') === 'false') {
          return false;
        }
      }

      return true;
    };

    const collectGiftVariantIds = (scope) => {
      const giftVariantIds = [];

      if (!scope) {
        return giftVariantIds;
      }

      const giftNodes = scope.querySelectorAll('[data-gift-item][data-gift-variant-id]');
      const seen = new Set();

      for (const giftNode of giftNodes) {
        const giftVariantId = giftNode.getAttribute('data-gift-variant-id');
        if (!giftVariantId || seen.has(giftVariantId) || !isGiftNodeAvailable(giftNode)) {
          continue;
        }

        seen.add(giftVariantId);
        giftVariantIds.push(giftVariantId);
      }

      return giftVariantIds;
    };

    const getSubscribeGiftScope = (productForm) => {
      const supplyPicker = productForm.querySelector('[data-supply-picker]');

      if (!supplyPicker) {
        return productForm;
      }

      return (
        supplyPicker.querySelector('[data-plan-card].is-selected') ||
        supplyPicker.querySelector('[data-plan-card="30"]') ||
        productForm
      );
    };

    const getBundleGiftVariantIds = (productForm, picker) => {
      if (isOtpPurchaseMode(picker, productForm)) {
        return [];
      }

      return collectGiftVariantIds(getSubscribeGiftScope(productForm));
    };

    const getAllPlanGiftVariantIds = (productForm, picker) => {
      return getBundleGiftVariantIds(productForm, picker);
    };
  
    const cartHasPlanGiftAlready = (cart, productForm, picker) => {
      const planGiftVariantIds = getAllPlanGiftVariantIds(productForm, picker);
      if (!cart || !cart.items || planGiftVariantIds.length === 0) {
        return false;
      }
  
      const planGiftSet = new Set(planGiftVariantIds.map(String));
  
      for (const cartItem of cart.items) {
        const role = cartItem.properties && cartItem.properties._bundle_role;
        if (role === 'gift' && planGiftSet.has(String(cartItem.variant_id))) {
          return true;
        }
      }
  
      return false;
    };
  
    const getExistingGiftVariantIds = (cart) => {
      const giftVariantIds = new Set();
  
      if (!cart || !cart.items) {
        return giftVariantIds;
      }
  
      for (const cartItem of cart.items) {
        const role = cartItem.properties && cartItem.properties._bundle_role;
        if (role === 'gift') {
          giftVariantIds.add(String(cartItem.variant_id));
        }
      }
  
      return giftVariantIds;
    };
  
    const shouldHideCartQty = (productForm) => {
      const hideQtyInput = productForm.querySelector('input[name="properties[_hide_qty]"]');
      return Boolean(hideQtyInput && hideQtyInput.value === 'true');
    };
  
    const buildBundleBuilderPayload = (productForm, picker, includeSellingPlan) => {
      const bundleKey = createBundleKey(productForm);
      const bundleProductId = getBundleProductIdFromForm(productForm);
      const hideQty = shouldHideCartQty(productForm);
      const rawItems = typeof picker.getBundleItems === 'function' ? picker.getBundleItems(includeSellingPlan) : [];
      const items = [];
  
      for (const rawItem of rawItems) {
        const properties = {
          _bundle_key: bundleKey,
          _atc_group: bundleKey,
          _bundle_role: 'main',
          _purchase_mode: includeSellingPlan ? 'subscribe' : 'otp',
          _atc_qty: String(rawItem.quantity || 1),
        };
  
        if (bundleProductId) {
          properties._bundle_product_id = bundleProductId;
        }
  
        if (hideQty) {
          properties._hide_qty = 'true';
        }
  
        const lineItem = {
          id: rawItem.id,
          quantity: rawItem.quantity,
          properties: properties,
        };
  
        if (includeSellingPlan && rawItem.selling_plan) {
          lineItem.selling_plan = rawItem.selling_plan;
        }
  
        items.push(lineItem);
      }
  
      const giftVariantIds = includeSellingPlan ? getBundleGiftVariantIds(productForm, picker) : [];
      for (const giftVariantId of giftVariantIds) {
        const giftProperties = {
          _bundle_key: bundleKey,
          _atc_group: bundleKey,
          _bundle_role: 'gift',
          _gift_source: 'pdp',
          _gift_context: 'subscribe',
          _atc_qty: '1',
        };
  
        if (bundleProductId) {
          giftProperties._bundle_product_id = bundleProductId;
        }
  
        if (hideQty) {
          giftProperties._hide_qty = 'true';
        }
  
        items.push({
          id: Number(giftVariantId),
          quantity: 1,
          properties: giftProperties,
        });
      }
  
      const atcItemCount = String(items.length);

      for (const item of items) {
        if (item.properties) {
          item.properties._atc_item_count = atcItemCount;
        }
      }

      const firstMainVariantId = rawItems.length > 0 ? String(rawItems[0].id) : '';
      const firstGiftVariantId = giftVariantIds.length > 0 ? String(giftVariantIds[0]) : '';
  
      return {
        items: items,
        firstVariantId: firstMainVariantId || firstGiftVariantId,
      };
    };
  
    const setBundleBuilderLoading = (productForm, picker, isLoading) => {
      const submitButton = productForm.querySelector('[data-atc-subscription]');
      const otpButton = productForm.querySelector('[data-atc-otp]');
  
      if (submitButton) {
        if (isLoading) {
          submitButton.classList.add('is-loading');
          submitButton.setAttribute('disabled', 'disabled');
        } else {
          submitButton.classList.remove('is-loading');
          if (picker && typeof picker.isBundleReady === 'function' && picker.isBundleReady()) {
            submitButton.removeAttribute('disabled');
          }
        }
      }
  
      if (otpButton) {
        if (isLoading) {
          otpButton.setAttribute('disabled', 'disabled');
        } else if (picker && typeof picker.isBundleReady === 'function' && picker.isBundleReady()) {
          otpButton.removeAttribute('disabled');
        }
      }
    };
  
    const showBundleBuilderError = (productForm, message) => {
      const errorContainer = productForm.querySelector('[data-cart-errors-container]');
      if (!errorContainer) {
        return;
      }

      const text = message == null ? '' : String(message).trim();

      if (!text || text === 'undefined' || text === 'null') {
        return;
      }
  
      errorContainer.textContent = text;
      errorContainer.hidden = false;
    };
  
    const clearBundleBuilderError = (productForm) => {
      const errorContainer = productForm.querySelector('[data-cart-errors-container]');
      if (!errorContainer) {
        return;
      }
  
      errorContainer.textContent = '';
      errorContainer.hidden = true;
    };
  
    const submitBundleBuilderCart = (productForm, picker, includeSellingPlan) => {
      if (!picker || typeof picker.isBundleReady !== 'function' || !picker.isBundleReady()) {
        const errorMessage = picker && typeof picker.getBundleEmptyError === 'function'
          ? picker.getBundleEmptyError()
          : 'Please choose at least one flavour to continue.';
        showBundleBuilderError(productForm, errorMessage);
        return Promise.resolve(null);
      }
  
      clearBundleBuilderError(productForm);
  
      const payloadData = buildBundleBuilderPayload(productForm, picker, includeSellingPlan);
  
      if (!payloadData.items || payloadData.items.length === 0) {
        showBundleBuilderError(productForm, picker.getBundleEmptyError());
        return Promise.resolve(null);
      }
  
      setBundleBuilderLoading(productForm, picker, true);
      bundleItemsAddInFlight = true;
  
      document.dispatchEvent(
        new CustomEvent('theme:bundle-atc:start', {
          bubbles: true,
          detail: {
            variantId: payloadData.firstVariantId,
            productId: getBundleProductIdFromForm(productForm),
          },
        })
      );

      const planGiftVariantIds = getAllPlanGiftVariantIds(productForm, picker);
      let skipAllGifts = false;

      for (const giftVariantId of planGiftVariantIds) {
        if (giftCartVariantIds.has(String(giftVariantId))) {
          skipAllGifts = true;
          break;
        }
      }

      const filteredItems = payloadData.items.filter((cartItem) => {
        const role = cartItem.properties && cartItem.properties._bundle_role;
        if (role !== 'gift') {
          return true;
        }

        if (skipAllGifts) {
          return false;
        }

        return !giftCartVariantIds.has(String(cartItem.id));
      });

      return fetch(getCartRootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: filteredItems,
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            showBundleBuilderError(productForm, response.description || response.message || 'Unable to add to cart.');
            return response;
          }

          return fetchCartJson().then((cart) => {
            refreshGiftLineKeyCache(cart);
            syncRebuyCartState(cart);
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
            scheduleGiftQtyNormalization();
            return cart;
          });
        })
        .catch(() => {
          showBundleBuilderError(productForm, 'Unable to add to cart.');
          return null;
        })
        .finally(() => {
          bundleItemsAddInFlight = false;
          setBundleBuilderLoading(productForm, picker, false);
        });
    };
  
    const handleBundleBuilderSubmit = (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) {
        return;
      }
  
      const productForm = form.closest('product-form[data-has-bundle-builder="true"]');
      if (!productForm) {
        return;
      }
  
      const picker = productForm.querySelector('[data-bundle-builder-picker]');
      if (!picker || typeof picker.getBundleItems !== 'function') {
        return;
      }
  
      event.preventDefault();
      event.stopImmediatePropagation();
      submitBundleBuilderCart(productForm, picker, !isOtpPurchaseMode(picker, productForm));
    };
  
    const handleBundleBuilderOtpClick = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }
  
      const otpButton = target.closest('[data-atc-otp]');
      if (!otpButton) {
        return;
      }
  
      const productForm = otpButton.closest('product-form[data-has-bundle-builder="true"]');
      if (!productForm) {
        return;
      }
  
      const picker = productForm.querySelector('[data-bundle-builder-picker]');
      if (!picker || typeof picker.getBundleItems !== 'function') {
        return;
      }
  
      if (otpButton.hasAttribute('disabled')) {
        return;
      }
  
      event.preventDefault();
      event.stopImmediatePropagation();
      submitBundleBuilderCart(productForm, picker, false);
    };
  
    document.addEventListener('submit', handleBundleBuilderSubmit, true);
    document.addEventListener('click', handleBundleBuilderOtpClick, true);
  
    document.addEventListener('rebuy:cart.ready', warmGiftLineKeyCache);
    document.addEventListener('rebuy:cart.ready', syncSmartCartHiddenQuantities);
    document.addEventListener('rebuy:smartcart.ready', warmGiftLineKeyCache);
    document.addEventListener('rebuy:smartcart.ready', syncSmartCartHiddenQuantities);
    document.addEventListener('rebuy:smartcart.ready', () => {
      patchThemeCartDrawerForRebuy();

      if (pendingRebuyCartOpen && openRebuySmartCart()) {
        closeThemeCartDrawer();
      }
    });
    document.addEventListener('rebuy:smartcart.show', syncSmartCartHiddenQuantities);
    document.addEventListener('rebuy:smartcart.cart-change', syncSmartCartHiddenQuantities);
    document.addEventListener('rebuy:smartcart.cart-change', handleSmartCartCartChange);
    document.addEventListener('rebuy:smartcart.cart-change', scheduleGiftQtyNormalization);
    document.addEventListener('rebuy:smartcart.line-item-increase', syncSmartCartHiddenQuantities);
    document.addEventListener('rebuy:smartcart.line-item-increase', scheduleGiftQtyNormalization);
    document.addEventListener('rebuy:smartcart.line-item-decrease', syncSmartCartHiddenQuantities);
    document.addEventListener('rebuy:smartcart.line-item-decrease', scheduleGiftQtyNormalization);
    document.addEventListener('rebuy:smartcart.line-item-decrease', syncHeaderCartToggleFromEvent);
    document.addEventListener('rebuy:smartcart.line-item-removed', syncSmartCartHiddenQuantities);
    document.addEventListener('rebuy:smartcart.line-item-removed', handleSmartCartBundleRemoval);
    document.addEventListener('rebuy:cart.add', handleRebuyDuplicateAdd);
    document.addEventListener('rebuy:cart.add', scheduleGiftQtyNormalization);
    document.addEventListener('rebuy:cart.add', warmGiftLineKeyCache);
  
    const smartCartObserver = new MutationObserver(syncSmartCartHiddenQuantities);
  
    smartCartObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  
    patchCartFetchForGiftQty();
    patchCartXhrForBundleMinQty();
    watchForSmartCart();
    warmGiftLineKeyCache();
    syncSmartCartHiddenQuantities();
    scheduleGiftQtyNormalization();
  
    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.
  })();
  